import { render, staticRenderFns } from "./DrumPad.vue?vue&type=template&id=535bd300&"
import script from "./DrumPad.vue?vue&type=script&lang=js&"
export * from "./DrumPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports